import { BaseController } from '../../../common/base/controller';
import {
  DocumentStatusSelectables,
  DocumentTypeSelectables,
} from '../categorizeIncomingDocument/categorizeIncomingDocument.constants';

import { DocumentStatus } from '../inbox.constants';

import _ from 'lodash';

export class DocumentListController extends BaseController {
  constructor(
    controllerService,
    DocumentStatus,
    InboxTabs,
    jobService,
    inboxDocumentService,
    $scope,
  ) {
    'ngInject';
    super({
      controllerService,
      DocumentStatus,
      InboxTabs,
      jobService,
      inboxDocumentService,
      $scope,
    });
  }

  get emptyList() {
    return !this.documentsList || this.documentsList.length === 0;
  }

  get featureInboxForNewAndDoneDocuments() {
    return this.isFeatureActive(
      this.FeatureNames.FF_INBOX_FOR_NEW_AND_DONE_DOCUMENTS,
    );
  }

  get featureInboxForRejectedDocumentsWithoutIBAN() {
    return this.isFeatureActive(
      this.FeatureNames.FF_INBOX_FOR_REJECTED_DOCUMENTS_WIHTOUT_IBAN,
    );
  }

  $onInit() {
    this.$scope.$on('initDocumentListController', this.realInit.bind(this));
    this.realInit();
  }

  realInit() {
    if (this.documentsList) {
      this.documentsList.length = 0;
    } else {
      this.documentsList = null;
    }

    if (this.featureInboxForNewAndDoneDocuments) {
      this.inboxType = this.InboxTabs.OPEN;
      this.requestDocumentsByType(this.InboxTabs.OPEN);
    } else if (this.featureInboxForRejectedDocumentsWithoutIBAN) {
      this.inboxType = this.InboxTabs.NEED_CLARIFICATON;
      this.requestDocumentsByType(this.InboxTabs.NEED_CLARIFICATON);
    }
  }

  getTranslationKeyForFaxStatus(val) {
    if (val === this.DocumentStatus.OK) {
      return 'inbox.fax.status.ok';
    }
    return _.find(DocumentStatusSelectables.selectables, (e) => {
      return e.key === val;
    }).value;
  }

  getTranslationKeyForFaxTyp(val) {
    return _.find(DocumentTypeSelectables.selectables, (e) => {
      return e.key === val;
    }).value;
  }

  resetSelectedDocumentWithFirst() {
    if (this.documentsList && this.documentsList.length > 0) {
      this.inboxDocumentService.selectedDocument = this.documentsList[0];
    }
  }

  requestDocumentsByType(type) {
    this.inboxType = type;

    switch (type) {
      case this.InboxTabs.OPEN:
        this.documentsListCallback('getNewDocuments');
        break;
      case this.InboxTabs.REJECTED:
        this.documentsListCallback('getRejectedDocumentsWithoutIBAN');
        break;
      case this.InboxTabs.CLOSED:
        this.documentsListCallback('getDoneDocuments');
        break;
      case this.InboxTabs.NEED_CLARIFICATON:
        this.documentsListCallback('getNeedClarificationDocuments');
        break;
    }
  }

  documentsListCallback(fn) {
    if (this.documentsList) {
      // clear documentsList
      this.documentsList.length = 0;
    }

    // clear current viewed document
    this.inboxDocumentService.selectedDocument = {};

    this.jobService[fn](this.envService.getTenant()).then((result) => {
      this.documentsList =
        _.map(result.data, (job) =>
          this.replaceCourierConstantsWithTranslations(job),
        ) || [];
      this.resetSelectedDocumentWithFirst();
    });
  }

  // on old jobs we may have courier constants in messages, replace them with translations
  replaceCourierConstantsWithTranslations(job) {
    const { envelope } = job;
    const states = _.values(DocumentStatus);

    if (envelope && envelope.rejectionReasonText) {
      _.map(states, (v) => {
        envelope.rejectionReasonText = envelope.rejectionReasonText.replace(
          v,
          this.$translate.instant(`app.document.rejectionReason.${v}`),
        );
      });
    }
    return job;
  }

  isActiveTab(type) {
    return this.inboxType === type;
  }

  isActiveItem(jobId) {
    if (!this.inboxDocumentService.selectedDocument) {
      return false;
    }
    return this.inboxDocumentService.selectedDocument._id === jobId;
  }

  chooseJob(job) {
    this.inboxDocumentService.selectedDocument = job;
  }
}
